import cn from 'classnames';

const Row = ({
  children, noGutters, className, ...attrs
}) => {
  const combinedClassName = cn('row', className, { 'no-gutters': noGutters });
  return (
    <div className={combinedClassName} {...attrs}>
      { children }
    </div>
  );
};

export default Row;
